import styled from 'styled-components';
import {
  color,
  container,
  fontWeight,
  spacing
} from '../../../theme';

export const StyledJoinUsFooterText = styled.div`
  font-weight: ${fontWeight('medium')};
  line-height: 1.25;
  color: ${color('text_subtle_inverse')};
  max-width: ${container('md')};
  margin-top: 0;
  margin-bottom: ${spacing('lg')};

  strong {
    font-weight: ${fontWeight('extraBold')};
  }
`;


